module.exports = __webpack_public_path__ + "static/media/star-rc.214140ae.png";